import React, { FC, useCallback, useState } from 'react';
import { ProductOut } from '../../../../store/api';
import {
    ExtendedManageSubscriptionOverview,
    ExtendedManageSubscriptionOverviewRow
} from './ExtendedManageSubscriptionOverview';
import {
    ExtendedManageSubscriptionIndividual,
    ExtendedManageSubscriptionIndividualRow
} from './ExtendedManageSubscriptionIndividual';
import { ExtendedManageSubscriptionSharedRow } from './ExtendedManageSubscriptionShared';
import { ExtendedManageLineShared } from '../../../../shared/subscription-management/types/ExtendedManageLineShared';
import { useShowAll } from '../../../../shared/subscription-management/ShowAllContext';
import { useQueryParams } from '../../../../shared/hooks/useQueryParams';

export type ExtendedManageSubscriptionTile = {
    product: ProductOut;
    overview: ExtendedManageSubscriptionOverview;
    individual: ExtendedManageSubscriptionIndividual;
    shared: ExtendedManageLineShared;
};

export const ExtendedManageSubscriptionTableTile: FC<ExtendedManageSubscriptionTile> = props => {
    const {
        showAll: { value: showAllParam }
    } = useQueryParams({ showAll: 'boolean' });

    const [open, setOpen] = useState(showAllParam || false);

    const onShowAll = useCallback(() => setOpen(true), []);
    useShowAll(onShowAll);

    return (
        <>
            <ExtendedManageSubscriptionOverviewRow
                {...props.overview}
                copiesListOpen={open}
                toggleCopiesList={() => setOpen(!open)}
            />
            {open ? (
                <>
                    <ExtendedManageSubscriptionIndividualRow {...props.individual} />
                    <ExtendedManageSubscriptionSharedRow {...props.shared} />
                </>
            ) : null}
        </>
    );
};
